export interface RecentPurchase {
  name: string
  city: string
  minutesAgo: number
}
/** Rotating "someone just bought" reminders shown in the corner of the page. */
export const recentPurchases: RecentPurchase[] = [
  { name: 'Anna', city: 'Krakowa', minutesAgo: 2 },
  { name: 'Tomasz', city: 'Warszawy', minutesAgo: 4 },
  { name: 'Katarzyna', city: 'Wrocławia', minutesAgo: 7 },
  { name: 'Piotr', city: 'Gdańska', minutesAgo: 9 },
  { name: 'Magdalena', city: 'Poznania', minutesAgo: 12 },
  { name: 'Michał', city: 'Łodzi', minutesAgo: 15 },
  { name: 'Agnieszka', city: 'Katowic', minutesAgo: 18 },
  { name: 'Paweł', city: 'Lublina', minutesAgo: 21 },
  { name: 'Joanna', city: 'Szczecina', minutesAgo: 26 },
  { name: 'Krzysztof', city: 'Bydgoszczy', minutesAgo: 31 },
]
